import classes from './TimeGrid.module.css';

export default function TimeGrid() {
  return (
    <div className={classes.timegrid}>
      {Array.from({ length: 24 }).map((x, idx) => {
        let hour = idx + 6;
        const tommorow = hour > 23;
        if (tommorow) {
          hour -= 24;
        }
        hour += ':00';
        if (tommorow) hour += ' (מחר)';
        return (
          <div className={classes.timegridRow} time={hour} key={`big+${idx}`}>
            <div className={classes.innergrid}>
              {Array.from({ length: 4 }).map((_, sidx) => {
                return (
                  <div
                    className={classes.hourFraction}
                    key={`small` + idx + sidx}
                  ></div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
